<template>
  <div>
    <div ref="comp" v-touch:swipe="swipeHandler" class="mobile-target">
      <div id="correspondence" class="application-section correspondence">
        <section id="postcodeSection">
          <div class="container is-fluid">
            <span class="displayblock form-label">Post Code</span>
              <b-input type="text" v-model.trim="postcode" placeholder="E1W 1AW" :tabIndex="sections.postcodeSection.tab" autocomplete="offPostcode">
            </b-input>
            <div>
              <b-button @click.stop.prevent="findAddress" :loading="searchingAddresses">Search</b-button>
              <div>{{resultsMessage}}</div>
            </div>
            <ChooseQuestion ref="addressSelect" question="Select an address" :options="addresses" @question-answered="addressSelected"
                              :isDropdownControlled="true" :isDisplayedBlock="true" />
            <p><a href="#" @click.prevent="setManualAddress">or enter address manually</a></p>
          </div>
        </section>
        <section id="manualAddressSection">
          <div class="container is-fluid">
            <div>
              <span class="displayblock form-label">Street</span>
              <b-input id="street" type="textarea" rows="2" v-model.trim="$v.correspondence.addressLine1.$model" placeholder="1 Road drive"
                       :class="[{mandatory: true}, {mandatoryFlex: true}, {error: $v.correspondence.addressLine1.$error }]"
                       :tabIndex="sections.manualAddressSection.tab" autocomplete="offPostcode"></b-input>
            </div>
            <div>
              <span class="displayblock form-label">Town/city</span>
              <b-input type="text" v-model.trim="$v.correspondence.town.$model" placeholder="Town"
                       :class="[{mandatory: true}, {error: $v.correspondence.town.$error }]"
                       :tabIndex="sections.manualAddressSection.tab" autocomplete="offPostcode"></b-input>
            </div>
            <div>
              <span class="displayblock form-label">Country</span>
              <AutocompleteQuestion question="" :class="{error: $v.correspondence.country.$error}"
                                    @question-answered="$v.correspondence.country.$model = $event;" closingTag="" :placeholder="'Country'"
                                    :isMandatory="true" :isExtraQuestion="false" :isNotDisplayed="true"
                                    :existingValue="$v.correspondence.country.$model" :tab="sections.manualAddressSection.tab"
                                    :dataSource="countries" />
            </div>
            <div>
              <span class="displayblock form-label">Post Code</span>
              <b-input type="text" v-model.trim="correspondence.postcode" placeholder="E1W 1AW"
                       :class="[{mandatory: true}, {error: $v.correspondence.postcode.$error || invalidPostcode }]"
                       :tabIndex="sections.manualAddressSection.tab" @focus="invalidPostcode = false" autocomplete="offPostcode"></b-input>
              <b-field v-if="invalidPostcode" :message="'Sorry, this is not a valid postcode'"></b-field>
            </div>
          </div>
        </section>
        <section id="phoneNumberSection">
          <div class="container is-fluid">
            <span class="displayblock form-label">Phone number</span>
            <b-field :message="'We will use this if we have any questions about your membership'"
                     :class="[{mandatory: true}]"></b-field>
            <VuePhoneNumberInput id="phoneNumber" v-model="number" :default-country-code="defaultCountry"
                                 color="dodgerblue" :dark="dark" :ignored-countries="countriesIgnored"
                                 :preferred-countries="countriesList" :loader="hasLoaderActive"
                                 clearable :error="hasErrorActive" :required="true"
                                 :class="['mb-2','contact-num', {error: $v.correspondence.phoneNumber.$error}]" @update="updatePhoneNumber"
                                 @phone-number-blur="validatePhoneNumber" :tabIndex="sections.phoneNumberSection.tab" autocomplete="offPostcode"/>
            <div v-if="!this.$store.state.isMobile" id="confirm-wrap">
              <div><button @click.stop.prevent="confirm" class="form-button" type="button">Next</button></div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <NextButton @clicked="navigateNext" />
  </div>
</template>
<script>
/* eslint no-unused-expressions: "warn" */
/* eslint no-plusplus: "warn" */
import ChooseQuestion from '@/components/ChooseQuestion.vue';
import '@/styles/inputform.scss';
import { mapGetters, mapState, mapMutations } from 'vuex';
import {
  required,
} from 'vuelidate/lib/validators';
import NextButton from '@/components/NextButton.vue';
import AutocompleteQuestion from '@/components/AutocompleteQuestion.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import api from '@/api';
import Mobile from '../mobile/mobile';
import Manager from '../applicationManager';
import Ga from '../ga';

export default {
  name: 'Correspondence',
  components: {
    ChooseQuestion,
    NextButton,
    VuePhoneNumberInput,
    AutocompleteQuestion,
  },
  data() {
    return {
      arrayOfAddressesJson: [],
      addressSummaryLines: [],
      isManualAddress: false,
      invalidPostcode: false,
      number: '',
      postcode: '',
      selectedAddress: '',
      correspondence: {},
      defaultCountry: 'GB',
      countriesList: ['GB', 'US', 'IE', 'DE', 'AE', 'SA', 'TR'],
      countriesIgnored: ['AF', 'AD', 'AL'],
      ukCountries: ['England', 'Scotland', 'Wales', 'Northern Ireland'],
      disabled: false,
      hasLoaderActive: false,
      hasErrorActive: false,
      dark: false,
      searchingAddresses: false,
      resultsMessage: '',
      sections: {
        postcodeSection: { tab: 0 },
        manualAddressSection: { tab: this.isMobile ? -1 : 0 },
        phoneNumberSection: { tab: this.isMobile ? -1 : 0 },
      },
      countries: [],
    };
  },
  created() {
    this.number = this.getCorrespondence.phoneNumber;
    this.correspondence = this.getCorrespondence;
  },
  async mounted() {
    Ga.sendCorrespondence(this.application.Type);

    if (this.isMobile) { this.initSections(); }

    this.countries = await Manager.getCountryList();
  },
  validations() {
    return {
      correspondence: {
        postcode: {
          required,
        },
        addressLine1: {
          required,
        },
        town: {
          required,
        },
        country: {
          required,
        },
        phoneNumber: {
          required,
        },
      },
    };
  },
  computed: {
    ...mapGetters(['getCorrespondence', 'isFinalSection', 'getIsOverseas']),
    ...mapState(['isMobile', 'application']),
    addresses() {
      return this.addressSummaryLines.map((summary, index) => ({ text: summary, value: index }));
    },
  },
  methods: {
    ...mapMutations(['completeCorrespondence']),
    navigateNext() {
      if (this.isFinalSection) {
        this.confirm();
      } else this.swipeHandler('left');
    },
    async isPostcodeValid(country, postcode) {
      if (this.arrayOfAddressesJson.length) {
        const address = this.arrayOfAddressesJson.find((a) => a.postcode === postcode);
        if (address) {
          this.correspondence.ukCountry = address.ukcountry;
          this.correspondence.gbFlag = address.gbflag;
          this.correspondence.country = address.country;

          return true;
        }
      }

      const result = await api.validatePostcode(postcode, country);

      if (result.data.IsValid) {
        this.correspondence.ukCountry = result.data.UkCountry;
        this.correspondence.gbFlag = result.data.GbFlag;
        this.correspondence.country = result.data.Country;
      }

      return result.data.IsValid;
    },
    async confirm() {
      this.$v.$touch();

      if (this.$v.$anyError) {
        this.$nextTick(() => {
          // - 100 is offset because of Sticky positional DNN header.
          window.scrollTo(0, (document.querySelector('.error').getBoundingClientRect().top - 100) + window.pageYOffset);
        });
        return;
      }
      // manual postcode check for UK country
      if (!this.isMobile) {
        const postcodeResult = await this.isPostcodeValid(this.correspondence.country, this.correspondence.postcode);
        if (!postcodeResult) {
          this.invalidPostcode = true;
          return;
        }
      }

      this.$emit('saveInProgress', true);

      this.completeCorrespondence(this.correspondence);

      window.scroll(0, 20);

      // Send to api
      const result = await Manager.saveCorrespondenceDetails();

      if (this.isUkStudent()) {
        this.options = await Manager.getCurrentFees();
        await Manager.setPaymentOption(this.options[0]);
      }

      const correspondenceResult = {
        message: result.message,
        successful: result.successful,
        reloadForm: result.reloadForm || false,
      };

      console.log(correspondenceResult);

      this.$emit('completed', correspondenceResult);
    },
    async findAddress() {
      const lookupValue = encodeURIComponent(this.postcode);

      if (lookupValue === '') {
        return;
      }
      this.searchingAddresses = true;
      // call the api to get the addresses:
      const result = await api.fetchAddressViaPostcode(lookupValue);
      this.arrayOfAddressesJson = result.data;
      // get this summary lines to display in the dropdown:
      this.addressSummaryLines = this.arrayOfAddressesJson.map((a) => a.summaryline);

      this.resultsMessage = `There are ${this.addressSummaryLines.length} matches`;
      this.searchingAddresses = false;
    },
    addressJsonToForm() {
      const selectedIndex = this.addressSummaryLines.findIndex((a) => a === this.selectedAddress);

      if (selectedIndex < 0) {
        return;
      }

      const selectedAddress = this.arrayOfAddressesJson[selectedIndex];
      const street = [selectedAddress.addressLine1, selectedAddress.addressLine2, selectedAddress.addressLine3].filter(Boolean).join(', ');

      this.correspondence.addressLine1 = street;
      this.correspondence.town = selectedAddress.posttown;
      this.correspondence.country = selectedAddress.country;
      this.correspondence.ukCountry = selectedAddress.ukcountry;
      this.correspondence.postcode = selectedAddress.postcode;
      this.correspondence.gbFlag = selectedAddress.gbflag;
      this.postcode = selectedAddress.postcode;
    },
    initSections() {
      Mobile.initSections(this.$el.querySelector('.application-section'));
    },
    isUkStudent() {
      return !this.getIsOverseas && this.application.Type === 'Student';
    },
    swipeHandler(direction) {
      Mobile.swipeHandler(direction, this);
    },
    async HasErrorInSection(currentSection) {
      if (currentSection === 'manualAddressSection') {
        this.$v.correspondence.addressLine1.$touch();
        this.$v.correspondence.town.$touch();
        this.$v.correspondence.country.$touch();
        this.$v.correspondence.postcode.$touch();
        const hasFailedVuelidations = this.$v.correspondence.addressLine1.$error || this.$v.correspondence.town.$error
          || this.$v.correspondence.country.$error || this.$v.correspondence.postcode.$error;

        if (hasFailedVuelidations) { return true; }

        const postcodeResult = await this.isPostcodeValid(this.correspondence.country, this.correspondence.postcode);
        if (!postcodeResult) {
          this.invalidPostcode = true;
          return true;
        }
      }
      if (currentSection === 'phoneNumberSection') {
        this.$v.correspondence.phoneNumber.$touch();
        return this.$v.correspondence.phoneNumber.$error;
      }
      return false;
    },
    addressSelected(a) {
      this.selectedAddress = a.text;
      this.addressJsonToForm();
    },
    setManualAddress() {
      this.isManualAddress = !this.isManualAddress;

      // reset fields in correspondence form
      this.correspondence.addressLine1 = '';
      this.correspondence.addressLine2 = '';
      this.correspondence.addressLine3 = '';
      this.correspondence.town = '';
      this.correspondence.country = '';
      this.correspondence.postcode = '';
      // reset postcode in api search and summeryline fields
      this.postcode = '';
      this.selectedAddress = '';
      this.$refs.addressSelect.resetSelected();
      // reset Select and address dropdown
      this.addressSummaryLines = [];

      if (this.isMobile) {
        this.swipeHandler('left');
      }
    },
    validatePhoneNumber() {
      this.$v.correspondence.phoneNumber.$touch();
    },
    updatePhoneNumber(payload) {
      this.correspondence.phoneNumber = payload.formattedNumber;
    },
    SetIndexes(current, next) {
      this.sections[current].tab = -1;
      this.sections[next].tab = 0;
    },
  },
};
</script>
<style lang="scss">
  @import '../styles/mixins';
 #phoneNumberSection {
   .contact-num {
  /*changes content the vue phone number component:*/
    .country-selector__label, .input-tel__label {
      top: -3px;
    }

    .input-tel__clear {
      height: 0;
      right: 140px;
      bottom: 8px;
    }
  .country-selector.has-value .country-selector__input {
    padding-top: 23px;

    @include browser(Trident/7.0) {
      padding-top: 20px;
      line-height: 10px;
    }
  }

    .input-tel.has-hint .input-tel__input, .input-tel.has-value .input-tel__input {
      @include DefaultBerlinskeFont(true);
    }

    .input-tel__clear__effect {
      width: 0;
    }
   }
 }

  #phoneNumber > div.flex-1 > div > button {
    @include browser(Trident/7.0) {
      display: none;
    }
  }

  button.country-selector__list__item > div.dots-text {
    color: black;
  }

  /*desktop IE fixes*/
  div.has-icons-left > span.icon.is-left > i.mdi-earth {
    @include browser(Trident/7.0) {
      display: none;
    }
  }
  div.has-icons-left > span.icon.is-right > i.mdi-close-circle {
    @include browser(Trident/7.0) {
      padding-bottom: 28px;
    }
  }

  /*design mobile view display phonenumber component nicely*/

  .mobile-view .mobile-target .correspondence {
    .country-selector__label {
      display: none;
    }

    #phoneNumber input {
      max-width: 100%;
    }

    #phoneNumber > div.flex-1 > div > button {
      display: none;
    }

    #phoneNumber > div.flex-1 > div > label.input-tel__label {
      display: none;
    }

    #phoneNumber > div.flex-1 > div {
      line-height: 0;

      input[type=tel] {
        font-size: 16px;
      }
    }
  }

  //put asterisk same line as div.span
  #phoneNumberSection > div > div.field.mandatory {
    display: flex;
  }

  .mandatoryFlex {
      display: flex !important;
      padding-bottom: 10px;
  }
</style>
